import { router } from "@inertiajs/react";
import { createColumnHelper } from "@tanstack/react-table";

import FaqCardComponent from "@/components/Cards/FaqComponent";
import Layout from "@/components/Layout";
import { moneyFormatterWithoutCurrency } from "@/utils/moneyFormat";

import InvestorsTableSection from "./sections/investorsTableSection";
import SummarySection from "./sections/summarySection";

const InvestmentManagerDashboard = ({ investors, totals, investment_manager_name }: any) => {
  const columnHelper = createColumnHelper();

  const investor_columns = [
    columnHelper.accessor("id", {
      header: () => "Código",
      cell: (info: any) => info.row.original.id,
    }),
    columnHelper.accessor("name", {
      header: () => "Nome",
      cell: (cellInfo: any) => (
        <div
          className="text-primary600 cursor-pointer hover:underline"
          onClick={() => router.get(`/investor/${cellInfo.row.original.id}`)}
        >
          {cellInfo.row.original.name}
        </div>
      ),
    }),
    columnHelper.accessor("email", {
      header: () => "Email",
      cell: (info: any) => info.row.original.email,
    }),
    columnHelper.accessor("total_shares", {
      header: () => "Cotas",
      cell: (info: any) => info.row.original.total_shares,
    }),
    columnHelper.accessor("invested_value_cents", {
      header: () => "Valor Investido",
      cell: (info: any) =>
        `R$ ${moneyFormatterWithoutCurrency(info.row.original.invested_value_cents / 100)}`,
    }),
    columnHelper.accessor("current_value_cents", {
      header: () => "Valor Atual",
      cell: (info: any) =>
        `R$ ${moneyFormatterWithoutCurrency(info.row.original.current_value_cents / 100)}`,
    }),
    columnHelper.accessor("appreciation_percentage", {
      header: () => "Rentabilidade",
      cell: (info: any) => {
        const percentage = info.row.original.appreciation_percentage;
        return percentage !== undefined && percentage !== null ? `${percentage.toFixed(2)}%` : "-";
      },
    }),
    columnHelper.accessor("dividend_yield_percentage", {
      header: () => "Yield",
      cell: (info: any) => {
        const yieldValue = info.row.original.dividend_yield_percentage;
        return yieldValue !== undefined && yieldValue !== null ? `${yieldValue.toFixed(2)}%` : "-";
      },
    }),
  ];

  return (
    <Layout>
      <div className="flex w-full flex-col justify-center gap-16 px-8 py-32 md:px-16">
        <SummarySection
          totalInvestors={totals.total_investors}
          totalCurrentValue={totals.total_current_value_cents}
          totalInvestedValue={totals.total_invested_value_cents}
          totalAppreciation={totals.total_appreciation_cents}
          investmentManagerName={investment_manager_name}
        />
        <InvestorsTableSection data={investors} columns={investor_columns} />
        <div className="pt-12">
          <FaqCardComponent variant="questionSection" />
        </div>
      </div>
    </Layout>
  );
};

export default InvestmentManagerDashboard;
